// Facility settings for registration: service points and patient/visit number formats
// (plan §3.3, §6.6). All gated on admin.facilities.manage by the API.
import {
  numberFormatSchema,
  servicePointSchema,
  type numberFormatInputSchema,
  type servicePointInputSchema,
  type updateServicePointRequestSchema,
} from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import { api } from './client.ts';

export const adminServicePointsQuery = queryOptions({
  queryKey: ['admin', 'service-points'],
  queryFn: () => api('GET', '/admin/service-points', { schema: z.array(servicePointSchema) }),
});

export function createServicePoint(body: z.input<typeof servicePointInputSchema>) {
  return api('POST', '/admin/service-points', { body, schema: servicePointSchema });
}

export function updateServicePoint(
  id: string,
  body: z.input<typeof updateServicePointRequestSchema>,
) {
  return api('PATCH', `/admin/service-points/${id}`, { body, schema: servicePointSchema });
}

export const numberFormatsQuery = queryOptions({
  queryKey: ['admin', 'number-formats'],
  queryFn: () => api('GET', '/admin/number-formats', { schema: z.array(numberFormatSchema) }),
});

export function saveNumberFormat(body: z.input<typeof numberFormatInputSchema>) {
  return api('PUT', '/admin/number-formats', { body, schema: z.array(numberFormatSchema) });
}
